import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import AppLayout from "@/components/layout/AppLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import DonorsList from "@/pages/admin/DonorsList";
import DonorAdd from "@/pages/admin/DonorAdd";
import DonorDetail from "@/pages/admin/DonorDetail";
import DonationsList from "@/pages/admin/DonationsList";
import DonationAdd from "@/pages/admin/DonationAdd";
import DonationView from "@/pages/admin/DonationView"; // <-- ADDED THIS IMPORT
import UtilizationsList from "@/pages/admin/UtilizationsList";
import UtilizationAdd from "@/pages/admin/UtilizationAdd";
import BeneficiariesList from "@/pages/admin/BeneficiariesList";
import ProjectsTree from "@/pages/admin/ProjectsTree";
import ImpactUpdates from "@/pages/admin/ImpactUpdates";
import DonorDashboard from "@/pages/donor/DonorDashboard";
import MyContributions from "@/pages/donor/MyContributions";
import ContributionDetail from "@/pages/donor/ContributionDetail";
import MyImpact from "@/pages/donor/MyImpact";
import DownloadCentre from "@/pages/donor/DownloadCentre";
import MyProfile from "@/pages/donor/MyProfile";
import UtilizationView from "@/pages/admin/UtilizationView";

function ProtectedLayout({ allow }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(user.role)) {
    return <Navigate to={user.role === "ADMIN" ? "/admin" : "/donor"} replace />;
  }
  return <AppLayout><Outlet /></AppLayout>;
}

function RootRedirect() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "ADMIN" ? "/admin" : "/donor"} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<RootRedirect />} />

          <Route element={<ProtectedLayout allow={["ADMIN"]} />}>
            <Route path="/admin" element={<AdminDashboard />} />
            
            {/* Donors */}
            <Route path="/admin/donors" element={<DonorsList />} />
            <Route path="/admin/donors/new/individual" element={<DonorAdd mode="individual" />} />
            <Route path="/admin/donors/new/corporate" element={<DonorAdd mode="corporate" />} />
            <Route path="/admin/donors/:donorId" element={<DonorDetail />} />
            
            {/* Donations */}
            <Route path="/admin/donations" element={<DonationsList />} />
            <Route path="/admin/donations/new" element={<DonationAdd />} />
            <Route path="/admin/donations/:id" element={<DonationView />} /> {/* <-- ADDED THIS ROUTE */}
            
            {/* Utilizations & Others */}
            <Route path="/admin/utilizations" element={<UtilizationsList />} />
            <Route path="/admin/utilizations/new" element={<UtilizationAdd />} />
            <Route path="/admin/utilizations/:id" element={<UtilizationView />} />
            <Route path="/admin/beneficiaries" element={<BeneficiariesList />} />
            <Route path="/admin/projects" element={<ProjectsTree />} />
            <Route path="/admin/impact" element={<ImpactUpdates />} />
          </Route>

          <Route element={<ProtectedLayout allow={["DONOR", "ADMIN"]} />}>
            <Route path="/donor" element={<DonorDashboard />} />
            <Route path="/donor/contributions" element={<MyContributions />} />
            <Route path="/donor/contributions/:donationId" element={<ContributionDetail />} />
            <Route path="/donor/impact" element={<MyImpact />} />
            <Route path="/donor/downloads" element={<DownloadCentre />} />
            <Route path="/donor/profile" element={<MyProfile />} />
          </Route>

          {/* Catch-all Redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}